<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <el-button type="primary" size="small" @click="addOrganization"
        >新建机构</el-button
      >
      <div>
        <el-input
          clearable
          v-model.trim="keyWords"
          placeholder="输入机构名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <el-table
      :data="organizationList.records"
      stripe
      lazy
      :load="load"
      style="width: 100%"
      size="small"
      @sort-change="sortChange"
      row-key="id"
      border
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="编号"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="departName"
        label="机构全名"
        width="180"
        header-align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orgCode"
        label="机构编号"
        width="380"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="机构电话"
        header-align="center"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-tooltip class="item" content="编辑" placement="top">
              <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                <span class="hmicon icon-bianji blue"></span>
              </button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="organizationList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total,  prev, pager, next, jumper, sizes"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="机构编号" prop="orgCode">
          <el-input
            :disabled="disabled"
            clearable
            v-model="ruleForm.orgCode"
            maxlength="20"
            size="small"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
          <!-- <div class="form-item-tip">
            编号为唯一值，仅支持英文和数字，不支持其他符号
          </div> -->
        </el-form-item>

        <el-form-item label="上级机构" prop="parentId">
          <el-cascader
            clearable
            ref="cascader"
            v-model="ruleForm.parentId"
            :props="props"
            :show-all-levels="false"
            v-if="dialogVisible"
            size="small"
          ></el-cascader>
          <!-- <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="机构全名" prop="departName">
          <el-input
            :disabled="disabled"
            clearable
            v-model.trim="ruleForm.departName"
            maxlength="30"
            size="small"
            placeholder="请输入机构全名"
          ></el-input>
        </el-form-item>
        <el-form-item label="机构电话" prop="mobile">
          <el-input
            clearable
            type="number"
            v-model="ruleForm.mobile"
            maxlength="20"
            size="small"
            placeholder="请输入机构电话"
          ></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="description">
          <el-input
            clearable
            style="width:300px"
            type="textarea"
            v-model="ruleForm.description"
            maxlength="20"
            size="small"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    const patternLocation = function(rule, val, callback) {
      let haveEmptyCondition = false;

      const reg = /^[0-9a-zA-Z_-]+$/;
      if (!reg.test(val)) {
        haveEmptyCondition = true;
      }
      if (haveEmptyCondition) {
        return callback(
          new Error("编号为唯一值，仅支持英文和数字，不支持其他符号")
        );
      }
      callback();
    }.bind(this);
    return {
      parentName: "",
      mode: "add",
      id: "",
      show: true,
      disabled: false,
      options: [
        {
          value: "1",
          label: "无上级机构"
        }
      ],
      title: "",
      ruleForm: {
        orgCode: "",
        departName: "",
        description: "",
        mobile: "",
        parentId: []
      },
      rules: {
        orgCode: [
          {
            required: true,
            trrger: "blur",
            message: "请输入机构编码"
          },
          { max: 20, message: "长度在20个字符内", trigger: "blur" },
          {
            required: true,
            validator: patternLocation,
            trigger: "blur"
          }
        ],
        parentId: {
          required: true,
          message: "请选择上级机构"
        },
        departName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入机构全名"
          },
          { max: 30, message: "长度在30个字符内", trigger: "blur" }
        ],
        mobile: [
          { min: 11, max: 12, message: "请输入正确的电话", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      keyWords: "",
      pageSize: 10,
      currentPage: 1,
      sort: {},
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.treeStruct;
                  v.label = v.departName;
                });
                res.result.records.unshift({
                  leaf: true,
                  value: "1",
                  label: "无上级机构"
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.treeStruct;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      }
    };
  },
  computed: mapGetters(["organizationList", "byIdOrganization"]),
  watch: {},
  created() {
    this.getParamsCookie();
  },
  mounted() {
    this.queryIndexList();
  },
  methods: {
    // blur() {
    //   const params = {
    //     orgCode: this.ruleForm.orgCode,
    //     departName: this.ruleForm.departName,
    //     id: this.id
    //   };
    //   if (
    //     this.ruleForm.orgCode.length > 0 ||
    //     this.ruleForm.departName.length > 0
    //   ) {
    //     this.$store.dispatch("checkOrganization", params);
    //   }
    // },
    addOrganization() {
      this.mode = "add";
      this.title = "新增机构";
      this.dialogVisible = true;
      this.disabled = false;
      this.show = true;
      setTimeout(() => {
        this.resetRuleForm();
      }, 0);

      // this.organizationList.records.forEach(v => {
      //   v.value = v.id;
      //   v.label = v.departName;
      //   this.options.push({
      //     label: v.departName,
      //     value: v.id
      //   });
      // });
      // for (let key in this.organizationList.records) {
      //   this.options.push({
      //     label: this.organizationList.records[key].departName,
      //     value:
      //       this.organizationList.records[key].parentId ||
      //       this.organizationList.records[key].orgCode
      //   });
      // }
    },
    queryIndexList() {
      this.$store.dispatch("queryOrganizationIndexList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        loginType: "store"
      });
    },
    queryList() {
      this.setParamsCookie();
      this.$store.dispatch("queryOrganizationList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        departName: this.keyWords,
        loginType: "store"
      });
    },
    setParamsCookie() {
      let searchCondition = {
        keyWords: this.keyWords
      };
      setCookie({
        key: "organizationListParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "organizationListParams",
        type: "session"
      });
      if (prams) {
        this.keyWords = prams.keyWords;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    search() {
      this.currentPage = 1;
      if (this.keyWords === "") {
        this.queryIndexList();
      } else {
        this.queryList();
      }
    },
    paging(page) {
      this.currentPage = page;
      if (this.keyWords === "") {
        this.queryIndexList();
      } else {
        this.queryList();
      }
    },
    sortChange(sort) {
      this.sort = sort;
      if (this.keyWords === "") {
        this.queryIndexList();
      } else {
        this.queryList();
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      if (this.keyWords === "") {
        this.queryIndexList();
      } else {
        this.queryList();
      }
    },

    load(tree, treeNode, resolve) {
      const { treeStruct } = tree;
      resolve([]);
      this.$store
        .dispatch("queryOrganizationListByParent", {
          parentId: treeStruct,
          loginType: "store"
        })
        .then(res => {
          if (res.code === "0" && res.result.length) {
            res.result.forEach(v => {
              v.hasChildren = Boolean(v.isParent);
            });
            resolve(res.result);
          } else {
            resolve([]);
          }
        });
    },
    edit(row) {
      this.mode = "edit";
      this.title = "编辑机构";

      this.id = row.id;
      const params = {
        id: this.id
      };
      this.dialogVisible = true;
      if (row.syncFlag !== "hemiao") {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
      this.show = false;
      this.$store.dispatch("queryByIdOrganization", params).then(res => {
        const result = res.result || {};

        if (res.code == 0) {
          result.parentId = [result.parentId];
          for (let key in result) {
            if (this.ruleForm.hasOwnProperty(key)) {
              setTimeout(() => {
                if (this.$refs.cascader) {
                  this.$refs.cascader.presentText = result.parentName;
                  if (result.orgType == 1) {
                    this.$refs.cascader.presentText = "无上级机构";
                  }
                }
              }, 0);
              // this.ruleForm.parentId = [result.parentId];
              this.ruleForm[key] = result[key];
            }
          }
        }
      });
    },
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          if (this.mode === "edit") {
            params.id = this.id;
          } else {
            params.id = "";
          }

          if (typeof params.parentId == "object") {
            params.parentId = params.parentId[params.parentId.length - 1];
            if (params.parentId == 1) {
              params.parentId = "";
            }
          }
          params.loginType = "store";

          this.$store.dispatch("checkOrganization", params).then(res => {
            if (res.code === "0") {
              this.$store
                .dispatch(
                  this.show ? "addOrganization" : "editOrganization",
                  params
                )
                .then(res => {
                  if (res.code === "0") {
                    this.$message({
                      message: "操作成功",
                      type: "success"
                    });
                    this.dialogVisible = false;
                    this.$store.commit("QUERY_ORGANIZATION_LIST", {
                      result: { record: [] }
                    });
                    this.queryIndexList();
                    // this.queryList();
                  }
                });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.formtip {
  line-height: 20px;
}
</style>
